/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Verify_TitleInputs */

const en_fc_dl_verify_title = /** @type {(inputs: Fc_Dl_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your download`)
};

/**
* | output |
* | --- |
* | "Verify your download" |
*
* @param {Fc_Dl_Verify_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_verify_title = /** @type {((inputs?: Fc_Dl_Verify_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Verify_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_verify_title(inputs)
});
export { fc_dl_verify_title as "fc.dl.verify.title" }